import type { WbsClient } from '@bldsoft/cappie/api/wbs'
import type { API } from '@setplex/tria-api'
import type { AdapterDefaults } from '../../index.h'

import { ensureOk } from '@bldsoft/cappie/rest'

export function use(
  client: WbsClient,
  notifications: API['notifications'],
  _api: API,
  _defaults: AdapterDefaults
): void {
  notifications.pushTokenFx.use(async (token) => {
    await ensureOk(
      client.post.api.v3.device.pushToken({
        body: {
          token,
          pushProviderType: 'FCM',
        },
      })
    )
  })
}
